import { useState } from "react";
import { useSpring, animated } from "react-spring";
import { Box, Typography, useTheme } from "@mui/material";

import { FONT_SECONDARY } from "@/theme/typography";
import telematic_imgUrl from "@/assets/images/features/telematic.png";
import telematic_thumbnailUrl from "@/assets/images/features/telematic_thumbnail.png";

import Section from "@/components/Section";

const TelematicsInsightsSection = () => {
  const theme = useTheme();
  const [imageLoaded, setImageLoaded] = useState(false); // Image loading state

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const fadeInProps = useSpring({
    opacity: imageLoaded ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  });

  const fadeInThumbProps = useSpring({
    opacity: imageLoaded ? 0 : 1, // Hide thumbnail when full image is loaded
    from: { opacity: 1 },
    config: { duration: 300 },
    filter: `blur(10px)`,
  });

  return (
    <Section pt={{ xs: 0, lg: 12.5 }} pb={{ xs: 7.5, lg: 12.5 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            maxWidth: { md: "1000px", lg: "680px" },
            marginBottom: { xs: "32px", lg: "0px" },
          }}
        >
          <Typography variant="h1" sx={{ marginBottom: "24px" }}>
            Advanced Real-Time Telematics             
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "500",
              fontFamily: FONT_SECONDARY,
              color: theme.palette.text.secondary,
            }}
          >
            Whether you want to take control of your personal vehicles or manage an extensive fleet, Trackmate provides you with the advanced tools you need to ensure safety, reduce loss, and gain the visibility you need for peace of mind. 
            <br /><br />
            Affordable, customizable, and scalable, Trackmate is the only all-in-one GPS tracking system you’ll need.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            maxWidth: "650px",
            position: "relative",

            img: { width: "100%", height: "auto" },
          }}
        >
          <animated.img
            src={telematic_thumbnailUrl}
            alt={`mobile`}
            style={{
              ...fadeInThumbProps,
              position: "relative",
              zIndex: 1,
              transition: "opacity 0.3s ease",
            }}
          />
          <animated.img
            src={telematic_imgUrl}
            alt="mobile phone"
            loading="lazy"
            style={{
              ...fadeInProps,
              position: "absolute",
              zIndex: 2,
              top: 0,
              left: 0,
              transition: "opacity 0.3s ease",
            }}
            onLoad={handleImageLoad}
          />
          <Box
            sx={{
              display: { xs: "none", lg: "block" },
              width: "100%",
              height: "100px",
              background:
                "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",
              position: "absolute",
              bottom: "0px",
              zIndex: 3,
            }}
          />
        </Box>
      </Box>
    </Section>
  );
};

export default TelematicsInsightsSection;
